<template>
  <div class="home">
    <van-sticky>
      <div class="header">
        <van-tabs
            v-model="currentId"
            line-width="4.0vw"
            line-height="1.13vw"
            @click="handleTab"
        >
          <van-tab
              :title="item.text"
              v-for="(item, index) in tabList"
              :key="index"
              :name="item.id"
          >
            <div class="tab-content van-hairline--top">
              <div
                  class="son-tabs van-hairline--bottom"
                  v-if="item.children && item.children.length > 0"
              >
                <div
                    class="son-tabs-item"
                    :class="sonCurrentId === It.id ? 'son-tabs-item-active' : ''"
                    v-for="(It, I) in item.children"
                    :key="I"
                    @click.stop="sonTabClick(It)"
                >
                  {{ It.text }}
                </div>
              </div>
              <div class="search-box" v-if="sonCurrentId === '1-1'">
                <!-- <div class="bind-box">
                    <div class="bind-box-left">
                        <div class="qrcode-label"></div>
                        <van-button v-if="!userInfo.doctorNo" plain type="danger" size="mini"
                            @click="bindDoctor">绑定医生</van-button>
                        <div class="bind_doctor_box" v-if="currentId == 1 && userInfo.doctorNo">
                            <div class="bind_doctor_box_left">
                                <span>已绑定医生：{{ userInfo.doctorNoName }}</span>
                                <span class="isOnline">（{{ userInfo.doctorStatusName }}）</span>
                            </div>
                            <van-button type="info" size="mini" @click="bindDoctorUpdate"
                                style="margin-left:8px">
                                更换/解绑
                            </van-button>
                            <van-button type="info" size="mini" @click="onCreateAsk"
                                style="margin-left:8px">
                                快速问诊
                            </van-button>
                        </div>
                    </div>
                    <van-icon name="fire-o" :dot="noReadNum > 0" @click="trackRemind" />
                </div>
                <div class="search-tag">
                    <span>二维码标签：{{ userInfo.tag || '无' }}</span>
                </div> -->
                <div class="user-info">
                  <van-button
                      v-if="!userInfo.doctorNo"
                      plain
                      type="danger"
                      size="mini"
                      @click="bindDoctor"
                  >绑定医生
                  </van-button>
                  <div
                      style="
                      display: flex;
                      justify-content: space-between;
                      align-items: center;
                    "
                  >
                    <div class="info-item flex">
                      用户编号：{{ userInfo.userNo || "-" }}
                      <div class="item">
                        {{
                          `${userInfo.nickName ? `(${userInfo.nickName})` : ""}`
                        }}
                      </div>
                      <router-link
                          class="link"
                          :to="`/reception/summary?userNo=${userInfo.userNo}`"
                      >服务记录
                      </router-link>
                    </div>

                    <!-- <van-button type="info" size="mini" @click="onCreateAsk">
                        快速问诊
                    </van-button> -->
                  </div>

                  <div class="info-item">
                    用户电话：{{ userInfo.mobile || "-" }}
                  </div>
                  <div style="display: flex; align-items: center">
                    <div class="info-item">
                      健康管家：{{ userInfo.assistantName || "-" }}
                    </div>
                    <div class="info-item">
                      绑定医生：{{ userInfo.doctorNoName || "-" }}
                    </div>
                  </div>
                  <div class="info-item">
                    注册时间：{{ userInfo.createTime || "-" }}
                  </div>
                  <div class="info-item flex">
                    <div class="item">
                      二维码标签：{{ userInfo.rootChannelName || "无" }}
                    </div>
                    <div
                        class="link btn"
                        @click="handleBindChannel"
                        v-if="userInfo.isNaturalChannel"
                    >
                      绑定渠道
                    </div>
                  </div>
                  <div class="info-item flex" v-if="userInfo.channelGrQrName">
                    <div class="item">
                      个人二维码：{{ userInfo.channelGrQrName }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="user_tab_box" v-else-if="sonCurrentId === '1-2'">
                <div
                    class="user_tab_item"
                    :class="{ user_tab_active: userTabActive == item.value }"
                    v-for="item in userTabList"
                    :key="item.value"
                    @click="handleUserTab(item.value)"
                >
                  {{ item.text }}
                </div>
              </div>
              <div
                  class="search-box"
                  v-else-if="['1-3', '2-1', '2-2', '2-3','5-1','5-2'].includes(sonCurrentId)"
              >
                <div class="search-button-wrapper">
                  <van-search
                      v-model="keyword"
                      :placeholder="
                      {
                        '1-3': '请输入昵称或电话号码查询...',
                        '2-1': '请输入患者姓名或电话号码查询...',
                        '2-2': '请输入患者姓名或手机号查询...',
                        '2-3': '请输入患者姓名或问诊编号查询',
                        '5-1': '请输入订单编号/用药人姓名/用户手机号查询',
                        '5-2': '请输入订单编号/商品名/手机号查询',
                      }[sonCurrentId]
                    "
                      show-action
                      :clearable="false"
                      @search="search"
                  >
                    <template #action>
                      <div @click="search" class="search-button">查询</div>
                    </template>
                  </van-search>
                  <van-icon
                      class="icon-box"
                      name="fire-o"
                      size="20"
                      :dot="noReadNum > 0"
                      @click="trackRemind"
                      v-if="sonCurrentId === '2-1'"
                  />
                </div>
              </div>

              <!-- 会诊管理 -->
              <div class="search-box" v-else-if="[4].includes(currentId)">
                <div class="search-button-wrapper">
                  <van-search
                      v-model="keyword"
                      :placeholder="
                      {
                        '4': '请输入患者姓名/手机号码/编号查询',
                      }[currentId]
                    "
                      show-action
                      :clearable="false"
                      @search="search"
                  >
                    <template #action>
                      <div @click="search" class="search-button">查询</div>
                    </template>
                  </van-search>
                </div>
              </div>
            </div>
          </van-tab>
        </van-tabs>
      </div>
    </van-sticky>
    <div class="content">
      <!-- 当前用户患者 -->
      <patient-info
          v-if="currentId === 1 && sonCurrentId === '1-1'"
          :currentPage="userMemberData.pageNo"
          :total="userMemberProp.total"
          :list="userMemberProp.list"
          @pageChange="pageChange"
          @init="onNeverRemind"
          @updateStatus="switchMedicatedTab"
      >
      </patient-info>
      <!-- 我的微信用户 -->
      <wx-user
          v-else-if="currentId === 1 && sonCurrentId === '1-2'"
          :userTabActive="userTabActive"
      >
      </wx-user>
      <!-- 待响应用户 -->
      <response-user
          v-else-if="currentId === 1 && sonCurrentId === '1-3'"
          ref="responseUserRef"
      ></response-user>
      <!-- 我的患者 -->
      <patient-info
          v-else-if="currentId == 2 && sonCurrentId === '2-1'"
          :currentPage="myMemberData.pageNo"
          :total="myMemberDataProp.total"
          :list="myMemberDataProp.list"
          @pageChange="pageChange"
          @init="onNeverRemind"
          show-tag
          @updateStatus="switchMedicatedTab"
      >
      </patient-info>
      <!-- 药品订单 -->
      <drugOrders v-else-if="currentId == 5 && sonCurrentId === '5-1'" ref="drugOrders">
      </drugOrders>
      <!-- 药品订单 -->
      <productOrder v-else-if="currentId == 5 && sonCurrentId === '5-2'" ref="productOrder">
      </productOrder>
      <!-- 预约患者 -->
      <ReservationList
          v-else-if="currentId == 2 && sonCurrentId === '2-2'"
          ref="medicatedRef"
      />
      <!-- 满意度评价 -->
      <evaluate-list
          v-else-if="currentId == 2 && sonCurrentId === '2-3'"
          ref="evaluateRef"
      ></evaluate-list>
      <!-- 排班 -->
      <treatment-schedule
          v-else-if="currentId == 3 && sonCurrentId === '3-1'"
      ></treatment-schedule>

      <!-- 预约日历 -->
      <ReservationCalendar
          v-else-if="currentId === 2 && sonCurrentId === '2-4'"
      />

      <!-- 会诊管理 -->
      <Consultation
          v-else-if="currentId == 4"
          :currentPage="consultationData.pageNo"
          :total="consultationProp.total"
          :list="consultationProp.list"
          @pageChange="pageChange"
          @init="onNeverRemind"
      />

      <!-- 专属医生 -->
      <MineReservationDoctors
          v-else-if="currentId == 3 && sonCurrentId === '3-2'"
          :currentPage="doctorsData.pageNum"
          :total="doctorsProp.total"
          :pageSize="doctorsData.pageSize"
          :list="doctorsProp.list"
          @pageChange="pageChange"
          @init="onNeverRemind"
      />
      <!--      工作室信息-->
      <StudioInformation
          v-else-if="currentId == 3 && sonCurrentId === '3-3'"
      ></StudioInformation>
      <!-- 视频咨询记录 -->
      <Record
          v-else-if="currentId == 3 && sonCurrentId === '3-4'"
      ></Record>
    </div>

    <!-- 绑定渠道 -->
    <van-dialog
        v-model="bindChannel.show"
        title="绑定渠道"
        confirmButtonColor="#1989fa"
        showCancelButton
        cancelButtonText="关闭"
        :before-close="onBindCodeClose"
    >
      <div class="bind-code">
        <div class="code-box">
          <van-form ref="codeFormRef">
            <div class="label">
              <span>*</span>
              请输入渠道专属邀请码
            </div>
            <van-field
                v-model="bindChannel.form.inviteCode"
                name="inviteCode"
                label=""
                placeholder="请输入"
                :rules="[{ required: true, message: '请输入渠道专属邀请码' }]"
                @input="fieldInput"
            />
          </van-form>
          <div class="code-info">
            <div class="label">邀请码对应渠道：</div>
            <div>{{ bindChannel.form.channelName }}</div>
          </div>
        </div>
      </div>
    </van-dialog>
    <van-dialog
        v-model="bindChannel.show2"
        title="提示"
        :showConfirmButton="false"
        showCancelButton
        cancelButtonText="关闭"
    >
      <div class="bind-code">
        <div class="code-box">
          该用户已产生处方订单，无法再绑定其他渠道。变更渠道请联系商务人员处理。
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import PatientInfo from "@/views/home/components/patientInfo.vue";
import WxUser from "@/views/home/components/wxUser.vue";
import ResponseUser from "@/views/home/components/responseUser.vue";
import StudioInformation from "@/views/home/studioInformation";
import Record from "@/views/home/components/record.vue";
import TreatmentSchedule from "@/components/treatment/schedule/index.vue";
import ReservationList from "@/views/reservation/list.vue";
import EvaluateList from "@/views/evaluate/evaluateList.vue";

import ReservationCalendar from "@/views/reservation/calendar.vue";
import Consultation from "@/views/home/components/consultation.vue";

import MineReservationDoctors from "@/components/mine/reservation/doctors.vue";

import weChatMixin from "../../mixin/weChat.js";
import drugOrders from "@/views/teamOrders/drugOrders/index.vue";
import productOrder from "@/views/teamOrders/productOrder/index.vue";
import {
  getUserInfo,
  getUserMemberList,
  getPageMemberListByUserNo,
  checkNoRead,
  getUserUpholdDropDownBoxAll,
  saveUserUphold,
  getPageConsultationList,
  bindChannel,
  getChannelInfo,
  getPageDoctorsList,
} from "../../api/home.js";
import {loginByOAuth2} from "../../api/weChat";

import {mapGetters} from "vuex";

export default {
  name: "home-index",
  mixins: [weChatMixin],
  components: {
    PatientInfo,
    WxUser,
    TreatmentSchedule,
    ReservationList,
    ResponseUser,
    EvaluateList,
    ReservationCalendar,
    Consultation,
    MineReservationDoctors,
    StudioInformation,
    Record,
    drugOrders,
    productOrder,
  },
  data() {
    return {
      noReadNum: 0,
      sonCurrentId: "1-1",
      currentId: 1,
      userTabList: [
        {value: 1, text: "全部"},
        // { value: 2, text: "已绑定医生" },
        // { value: 3, text: "未绑定医生" },
      ],
      userTabActive: 1,
      tabLoading: false,
      // 用户的患者
      wxUserId: "",
      userInfo: {},
      userMemberData: {
        userNo: "",
        pageNo: 1,
        pageSize: 5,
      },
      userMemberProp: {
        total: 0,
        list: [],
      },
      showPicker: false,
      value: "",
      userUpholdId: "",
      userId: "",
      columns: [],
      // 我的患者
      myMemberData: {
        assistantNo: "",
        pageNo: 1,
        pageSize: 5,
      },

      keyword: "",
      myMemberDataProp: {
        total: 0,
        list: [],
      },
      currentPage: 1,
      // 药品订单
      drugOrderData: {
        assistantNo: "",
        pageNo: 1,
        pageSize: 5,
      },
      drugOrderDataProp: {
        total: 0,
        list: [],
      },
      // 商品订单
      productOrderData: {
        assistantNo: "",
        pageNo: 1,
        pageSize: 5,
      },
      productOrderDataProp: {
        total: 0,
        list: [],
      },
      appointmentKeyWord: "",
      consultationData: {
        memberName: "",
        pageNo: 1,
        pageSize: 5,
      },
      consultationProp: {
        total: 0,
        list: [],
      },
      bindChannel: {
        show: false,
        show2: false,
        sumbit: true,
        inputFlag: false,
        form: {
          inviteCode: "",
          channelCode: "",
          userCode: "",
          channelName: "",
        },
      },
      doctorsData: {
        pageNum: 1,
        pageSize: 999,
      },
      doctorsProp: {
        total: 0,
        list: [],
      },
    };
  },
  async activated() {
    this.userUpholdId = this.$store.state.userUpholdId;
    // 用户首次打开链接没有 code，调接口获取 OAuth2 链接
    const code = this.getUrlKey("code");
    if (!code) {
      this.loginByOAuth2();
    } else {
      if (!this.$store.state.assistantNo) {
        await this.getOwnInfo(code);
      }
      if (sessionStorage.getItem("userToken")) {
        this.wxConfigAuth();
        this.getUserUpholdDropDownBoxAll();
      }
      if (this.sonCurrentId === "1-1" || this.sonCurrentId == "2-1") {
        this.myMemberData.assistantNo = this.$store.state.assistantNo;
        this.getMyMemberList();
      }
    }
  },
  methods: {
    getUserUpholdDropDownBoxAll() {
      getUserUpholdDropDownBoxAll().then((res) => {
        if (res.code == 0) {
          this.columns = res.data;
          if (this.userUpholdId) {
            let index = res.data.findIndex(
                (item) => item.value == this.userUpholdId
            );
            index > -1 && (this.value = res.data[index].text);
          }
        }
      });
    },
    checkNoRead() {
      checkNoRead().then((res) => {
        if (res.code == 0) {
          this.noReadNum = res.data;
        }
      });
    },
    loginByOAuth2() {
      if (window.location.hostname !== "localhost") {
        const authorUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${
            process.env.VUE_APP_QYWXCORPID
        }&redirect_uri=${encodeURIComponent(
            window.location.href
        )}&response_type=code&scope=snsapi_privateinfo&state=STATE&agentid=${
            process.env.VUE_APP_QYWXAGENTID
        }#wechat_redirect`;
        window.location.href = authorUrl;
      }
    },
    async getOwnInfo(code) {
      this.tabLoading = true;
      let data = {
        code: code,
      };
      await loginByOAuth2(data)
          .then((res) => {
            if (res.code == 0) {
              this.$store.dispatch("setAssistantNo", res.data.refUserNo);
              this.$store.dispatch("setUserInfo", res.data);
              sessionStorage.setItem("userToken", res.data.userSessionStr);
              this.wxConfigAuth();
              this.getUserUpholdDropDownBoxAll();
            }
            this.tabLoading = false;
          })
          .catch(() => {
            this.tabLoading = false;
            setTimeout(() => {
              const authorUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${
                  process.env.VUE_APP_QYWXCORPID
              }&redirect_uri=${encodeURIComponent(
                  window.location.origin
              )}&response_type=code&scope=snsapi_privateinfo&state=STATE&agentid=${
                  process.env.VUE_APP_QYWXAGENTID
              }#wechat_redirect`;
              window.location.href = authorUrl;
            }, 1000);
          });
    },
    // 获取路径中的参数（code等）
    getUrlKey(name) {
      return (
          decodeURIComponent(
              (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
                  location.href
              ) || ["", ""])[1].replace(/\+/g, "%20")
          ) || null
      );
    },
    // jssdk权限注入
    wxConfigAuth() {
      console.log("before：" + window.location.href);
      let url = window.location.href.split("#")[0];
      /* let index = url.indexOf('?')
       if(index > -1){
           url = url.slice(0, index)
       }
       console.log(url)*/
      const jsApiList = ["getContext", "getCurExternalContact"];
      this.wxAgentConfig(url, jsApiList, () => {
        this.getContext();
      });
    },
    getContext() {
      let that = this;
      wx.invoke("getContext", {}, function (res) {
        if (res.err_msg === "getContext:ok") {
          // 从单聊会话的工具栏进入 single_chat_tools
          that.entry = res.entry;
          if (that.entry === "single_chat_tools") {
            that.getCurExternalContact();
          } else {
            //错误处理
            this.$notify({
              message: "请在企业微信中打开该网址！",
              type: "warning",
            });
          }
        } else {
          this.$notify("获取环境失败，联系管理员！");
          return false;
        }
      });
    },
    getCurExternalContact(isCheckSelf) {
      let that = this;
      wx.invoke("getCurExternalContact", {}, function (res) {
        if (res.err_msg == "getCurExternalContact:ok") {
          //返回当前外部联系人userId
          // that.wxUserId = res.userId
          that.getUserInfo(
              {
                externalUserId: res.userId,
                assistantNo: that.$store.state.assistantNo,
              },
              isCheckSelf
          );
          // 授权后，根据scrmAuthStatus 判断接下来的操作
          // that.getWxUserIdAfter(userId)
        } else {
          that.$notify("获取企业微信userId失败，请联系管理员");
          // that.$message.warning("获取企业微信userID失败，请联系管理员");
        }
      });
    },
    // 获取系统内部用户信息
    getUserInfo(data, isCheckSelf) {
      getUserInfo(data).then((res) => {
        if (res.code == 0) {
          this.userInfo = res.data;
          this.userMemberData.userNo = res.data.userNo;
          this.$store.dispatch("setUserNo", res.data.userNo);
          this.$store.dispatch("setAssistantName", res.data.nickName);
          this.$store.dispatch("setUserUpholdId", res.data.userUpholdId);
          this.userUpholdId = res.data.userUpholdId;
          this.userId = res.data.id;
          let index = this.columns.findIndex(
              (item) => item.value == this.userUpholdId
          );
          index > -1 && (this.value = this.columns[index].text);
          if (!isCheckSelf) {
            this.checkNoRead();
            this.getUserMemberList();
          }
        }
      });
    },
    // 获取该用户的患者列表
    getUserMemberList() {
      return new Promise((resolve, reject) => {
        if (!this.userMemberData.userNo) {
          reject(false);
        } else {
          this.tabLoading = true;
          getPageMemberListByUserNo(this.userMemberData)
              .then((res) => {
                if (res.code == 0) {
                  this.userMemberProp.total = res.data.total;
                  this.userMemberProp.list = res.data.list;
                }
                this.tabLoading = false;
                resolve(true);
              })
              .catch(() => {
                this.tabLoading = false;
                reject(false);
              });
        }
      });
    },

    // 获取会诊管理列表
    getConsultationList() {
      return new Promise((resolve, reject) => {
        this.tabLoading = true;
        getPageConsultationList(this.consultationData)
            .then((res) => {
              if (res.code == 0) {
                this.consultationProp.total = res.data.total;
                this.consultationProp.list = res.data.list;
              }
              this.tabLoading = false;
              resolve(true);
            })
            .catch(() => {
              this.tabLoading = false;
              reject(false);
            });
      });
    },

    // 分页查询
    pageChange(pageNo) {
      if (this.currentId == 4) {
        this.consultationData.pageNo = pageNo;
        this.getConsultationList();
      } else if (this.sonCurrentId == "1-1") {
        this.userMemberData.pageNo = pageNo;
        this.getUserMemberList();
      } else if (this.sonCurrentId == "2-1") {
        this.myMemberData.pageNo = pageNo;
        this.getMyMemberList();
      }
    },
    // 获取我的患者列表
    getMyMemberList() {
      return new Promise((resolve, reject) => {
        this.tabLoading = true;
        getUserMemberList({...this.myMemberData, keyword: this.keyword})
            .then((res) => {
              if (res.code == 0) {
                this.myMemberDataProp.total = res.data.total;
                this.myMemberDataProp.list = res.data.list;
              }
              this.tabLoading = false;
              resolve(true);
            })
            .catch(() => {
              this.tabLoading = false;
              reject(false);
            });
      });
    },
    search() {
      if (this.sonCurrentId === "2-1") {
        this.myMemberData.pageNo = 1;
        this.myMemberData.assistantNo = this.$store.state.assistantNo;
        this.getMyMemberList();
      } else if (this.sonCurrentId === "2-2") {
        this.$refs.medicatedRef.setPageParams(this.keyword);
      } else if (this.sonCurrentId === "1-3") {
        this.$refs.responseUserRef.setPageParams(this.keyword);
      } else if (this.sonCurrentId === "2-3") {
        this.$refs.evaluateRef.setPageParams(this.keyword);
      } else if (this.sonCurrentId === "5-1") {
        this.$refs.drugOrders.setPageParams(this.keyword);
      } else if (this.sonCurrentId === "5-2") {
        this.$refs.productOrder.setPageParams(this.keyword);
      }
    },
    // 头部tab
    handleTab(active) {
      const find = this.tabList.find((row) => row.id === active);
      if (find) {
        if (find.children && find.children.length)
          this.sonTabClick(find["children"][0]);
        this.checkNoRead();
        if (this.currentId == 4) {
          this.consultationData.pageNo = 1;
          this.getConsultationList();
        }
      }
    },
    sonTabClick({id}) {
      this.sonCurrentId = id;
      this.keyword = "";
      if (this.sonCurrentId == "1-1") {
        this.userMemberData.pageNo = 1;
        this.getUserMemberList();
      } else if (this.sonCurrentId == "2-1") {
        this.myMemberData.pageNo = 1;
        this.myMemberData.assistantNo = this.$store.state.assistantNo;
        this.getMyMemberList();
      } else if (this.sonCurrentId == "3-2") {
        this.doctorsData.pageNum = 1;
        this.getDoctorsList();
      }
    },
    switchMedicatedTab() {
      this.currentId = 2;
      this.sonTabClick({id: "2-2"});
    },
    onConfirm(value) {
      let data = {
        id: this.userId,
        userUpholdId: value.value,
      };
      saveUserUphold(data).then((res) => {
        if (res.code == 0) {
          this.userUpholdId = value.value;
          this.value = value.text;
          this.showPicker = false;
          this.$toast.success("修改客户关系成功");
        }
      });
      // this.getUserMemberList()
    },
    // 跟进提醒小红点
    trackRemind() {
      this.$router.push("/trackRemind");
    },
    handleUserTab(value) {
      if (value == this.userTabActive) return;
      this.userTabActive = value;
    },
    bindDoctorUpdate() {
      let userNos = [this.userInfo.userNo];
      sessionStorage.setItem("userNos", JSON.stringify(userNos));
      this.$router.push({
        path: "/bindDoctorUpdate",
        query: {
          doctorNoName: this.userInfo.doctorNoName,
        },
      });
    },
    bindDoctor() {
      let userNos = [this.userInfo.userNo];
      sessionStorage.setItem("userNos", JSON.stringify(userNos));
      this.$router.push({
        path: "/bindDoctor",
        query: {
          nickName: this.userInfo.nickName,
        },
      });
    },
    onNeverRemind() {
      this.pageChange(1);
    },
    onCreateAsk() {
      // if(!this.userMemberData.userNo) return
      this.$router.push({
        path: "/createAsk",
        query: {
          askType: 12,
          userNo: this.userMemberData.userNo,
          assistantNo: this.$store.state.assistantNo,
        },
      });
    },
    handleBindChannel() {
      if (
          this.userInfo.prescriptionQuantity &&
          this.userInfo.prescriptionQuantity >= 1
      )
        this.bindChannel.show2 = true;
      else this.bindChannel.show = true;
    },
    onBindCodeClose(action, done) {
      if (action == "cancel") {
        this.bindChannel.form.inviteCode = "";
        this.$refs.codeFormRef.resetValidation();
        done();
      } else {
        this.$refs.codeFormRef
            .validate()
            .then(() => {
              if (!this.bindChannel.sumbit) return false;
              this.bindChannel.sumbit = false;
              this.bindChannel.form.userCode = this.userInfo.userNo;
              bindChannel(this.bindChannel.form)
                  .then((res) => {
                    if (res.code == 0) {
                      this.bindChannel.form.inviteCode = "";
                      this.$refs.codeFormRef.resetValidation();
                      this.$toast.success("绑定渠道成功");
                      this.getCurExternalContact(true);
                    }
                  })
                  .finally(() => {
                    this.bindChannel.sumbit = true;
                    done();
                  });
            })
            .catch(() => {
              done(false);
            });
      }
    },
    fieldInput() {
      if (this.bindChannel.inputFlag) return;
      this.bindChannel.inputFlag = true;
      let that = this;
      setTimeout(function () {
        that.bindChannel.inputFlag = false;
        getChannelInfo(that.bindChannel.form.inviteCode).then((res) => {
          if (res.code == 0) {
            that.bindChannel.form.channelCode = res.data ? res.data.code : "";
            that.bindChannel.form.channelName = res.data ? res.data.name : "";
          } else {
            that.$toast(res.message);
          }
        });
      }, 500);
    },

    // 获取我的-专属医生
    getDoctorsList() {
      return new Promise((resolve, reject) => {
        this.tabLoading = true;
        getPageDoctorsList(this.doctorsData)
            .then((res) => {
              if (res.code == 0) {
                res.data.list = res.data.list || [];
                let list = res.data.list.filter(
                    (item) =>
                        item.isBindHis &&
                        item.isHaveOpenPrescription == 1 &&
                        item.doctorStatus == 0 &&
                        item.isSchedule == 1
                );
                this.doctorsProp.total = list.length;
                this.doctorsProp.list = list;
              }
              this.tabLoading = false;
              resolve(true);
            })
            .catch(() => {
              this.tabLoading = false;
              reject(false);
            });
      });
    },
  },
  computed: {
    ...mapGetters(["getLoginRole"]),
    tabList() {
      return [
        {
          text: "用户管理",
          id: 1,
          children: [
            {
              text: "当前用户",
              id: "1-1",
            },
            {
              text: "我的用户",
              id: "1-2",
            },
            // {
            //   text: "待响应用户",
            //   id: "1-3",
            // },
          ],
        },
        {
          text: "患者管理",
          id: 2,
          children: [
            {
              text: "我的患者",
              id: "2-1",
            },
            {
              text: "预约患者",
              id: "2-2",
            },
            {
              text: "满意度评价",
              id: "2-3",
            },
            {
              text: "预约日历",
              id: "2-4",
            },
          ].filter((item) => {
            if (this.getLoginRole === "医助") return true;
            return item.text !== "预约患者";
          }),
        },
        {
          text: "团队订单",
          id: 5,
          children: [
            {
              text: "药品订单",
              id: "5-1",
            },
            {
              text: "商品订单",
              id: "5-2",
            },
          ],
        },
        {
          text: "会诊管理",
          id: 4,
          children: [],
        },
        {
          text: "我的",
          id: 3,
          children: [
            {
              text: '排班', id: '3-1',
            },
            {
              text: '专属预约', id: '3-2',
            },
            {
              text: "工作室信息",
              id: "3-3",
            },
            // {
            //   text: "视频咨询记录",
            //   id: "3-4",
            // },
          ].filter((item) => {
            if (this.getLoginRole === "医助") return ['工作室信息'].includes(item.text);
            return item.text !== "工作室信息";
          }),
        },
      ].filter((item) => {
        if (this.getLoginRole === "医助") {
          return item.text !== "会诊管理"
        } else {
          return item.text !== "团队订单"
        }
        // return true;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/base";

.home {
  font-size: 14px;
  box-sizing: border-box;
  position: relative;

  .header {
    /* top: 0;
    position: sticky;
    width: 100%;
    z-index: 99; */

    :deep(.van-tabs) {
      .van-tabs__wrap {
        height: 49px;
        line-height: 49px;
      }

      .van-tab {
        .van-tab__text {
          font-size: 16px;
          color: #666666;
        }

        &.van-tab--active {
          .van-tab__text {
            font-size: 18px;
            color: #0082ef;
            font-weight: bold;
          }
        }
      }

      .van-tabs__line {
        background-color: #0082ef;
        bottom: 5vw;
      }
    }

    .tab-content {
      background: #ffffff;
      box-shadow: 0px 6px 10px 0px rgba(51, 51, 51, 0.1);

      .son-tabs {
        padding: 0 15px;
        display: flex;

        .son-tabs-item {
          cursor: pointer;
          padding: 15px 18px;
          font-size: 14px;
          color: #999999;
        }

        .son-tabs-item-active {
          font-weight: bold;
          color: #0082ef;
        }
      }

      .search-box {
        padding: 0 15px;

        .bind-box {
          display: flex;
          justify-content: space-between;
          align-items: center;

          .bind-box-left {
            display: flex;
            align-items: center;
            cursor: pointer;

            .qrcode-label {
              height: 60px;
              display: flex;
              align-items: center;

              .label {
                flex: none;
              }

              .value {
                word-break: break-all;
                max-width: 150px;
              }
            }

            .bind_doctor_box {
              display: flex;
              justify-content: space-between;
              padding: 10px 0;
              align-items: center;

              .bind_doctor_box_left {
                display: flex;
                align-items: center;
                color: #666666;
                font-size: 14px;

                .isOnline {
                  color: #0fbc54;
                }
              }
            }
          }
        }

        .user-info {
          position: relative;
          padding: 15px 0;

          .info-item {
            font-size: 15px;
            color: #333;
            padding: 5px 0;
            flex: 1;

            &.flex {
              display: flex;
              align-items: center;

              > .item {
                flex: 1;
              }

              > .btn {
                background: #f6fbff;
                color: #0082ef;
              }
            }
          }

          > .link {
            position: absolute;
            right: 0;
            bottom: 10px;
          }

          .link {
            background: #f7fbff;
            color: #f60;
            padding: 7px 15px;
            border-radius: 8px;
            font-size: 14px;
          }
        }

        .van-cell {
          padding-left: 0;
          padding-right: 0;
          width: auto;
          min-width: 270px;
          font-size: 14px;
        }

        .van-cell::after {
          left: 0;
          right: 0;
        }

        :deep(.van-icon) {
          font-size: 16px;
          cursor: pointer;
        }

        .van-button--danger {
          border: 1px solid #e1e8ef;
          border-radius: 8px;
          height: 35px;
          font-size: 14px;
          width: auto;
          box-sizing: border-box;
        }

        .search-button-wrapper {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 15px 0;

          :deep(.van-search) {
            width: 100%;
            padding: 0;

            .van-search__action {
              padding: 0;
            }

            .van-field__left-icon {
              display: none;
            }

            .van-search__content {
              padding: 0 15px;
              background-color: #ffffff;
              border-radius: 8px 0 0 8px;
              opacity: 1;
              border: 1px solid #e1e8ef;
              border-right-color: transparent;
            }
          }

          .search-button {
            width: 72px;
            height: 44px;
            line-height: 44px;
            background: #0082ef;
            border-radius: 0px 8px 8px 0px;
            opacity: 1;
            color: #ffffff;
            text-align: center;
          }

          .icon-box {
            margin-left: 20px;
          }
        }
      }

      .user_tab_box {
        width: 100%;
        height: 49px;
        display: flex;
        color: #666666;
        font-weight: 500;
        font-size: 14px;
        background: #fff;

        .user_tab_item {
          flex: 1;
          height: 49px;
          line-height: 49px;
          text-align: center;
          cursor: pointer;
        }

        .user_tab_active {
          color: #0082ef;
        }
      }
    }
  }

  .content {
    background: #f2f2f2;
    padding: 15px 10px 10px;

    :deep(.patient-info) {
      &:first-of-type {
        margin-top: 0;
      }
    }

    :deep(.user) {
      margin-top: 0;
    }
  }
}

.bind-code {
  .code-box {
    padding: 20px 20px 30px;
    font-size: 15px;

    .label {
      padding-bottom: 8px;

      > span {
        color: #f00;
      }
    }

    #{$deep} .van-cell.van-field {
      padding: 0;
      font-size: 15px;

      .van-field__body {
        padding: 6px 12px;
        border: 1px solid #e1e8ef;
        border-radius: 4px;
      }
    }

    .code-info {
      padding-top: 14px;
    }
  }
}
</style>
